/**
 * Created by eriksundqvist on 28/06/16.
 */
/* @flow */
import React, {PropTypes} from 'react';
import Translate from 'react-translate-component';
import { WorkerService } from 'frilans-finans';
import { Spinner, SpinnerButton } from 'components';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

var _ = require('lodash');

export class AddCoworker extends React.Component {

  static propTypes = {
    addNewCoworker: PropTypes.func.isRequired,
    addCoworker: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired,
    invoice: PropTypes.object
  };

  constructor (props) {
    super(props);

    this.state = {
      fetching: true,
      coworkers: [],
      total: null,
      perPage: null,
      addingCoworker: false,
      selectedCoworker: null,
      coworkerSearch: false
    };

    this.addCoworker = this.addCoworker.bind(this);
    this.parseInvoiceUsers = this.parseInvoiceUsers.bind(this);
    this.handleCoworkerChange = this.handleCoworkerChange.bind(this);
  }

  parseInvoiceUsers (invoice) {
    let invoiceUsers = this.state.coworkers;
    if (invoice && invoice.invoiceUser) {
      for (let i = 0; i<invoice.invoiceUser.length; i++) {
        let invoiceUser = invoice.invoiceUser[i];
        let existingUser = _.find(this.state.coworkers, function (o) { o.id === parseInt(invoiceUser.userId); });
        if (existingUser) {
          invoiceUsers[existingUser.id].disabledInSelect;
        } else {
          invoiceUsers.push({
            id: parseInt(invoiceUser.userId),
            disabledInSelect: true
          });
        }
      }
    }

    this.setState({
      coworkers: invoiceUsers
    });
  }

  componentDidMount () {
    this.parseInvoiceUsers(this.props.invoice);
  }

  componentWillMount () {
    this.fetchCoworkers();
  }

  fetchCoworkers () {
    this.setState({
      fetching: true
    }, function () {
      WorkerService.get(this.state.page)
        .then((response) => {
          this.handleFetchWorkersResponse(response);
        }).catch(() => {
          this.setState({
            fetchError: true,
            fetching: false
          });
        });
    });
  }

  handleFetchWorkersResponse (apiResult) {
    let coworkers = [];
    apiResult.collection.forEach(result => {
      if (!this.props.invoice.invoiceUser.find(worker => +worker.userId === +result.id)) {
        coworkers.push(result);
      }
    });
    this.setState({
      coworkers: coworkers,
      fetching: false,
      fetchError: false
    });

    if (!this.state.coworkerSearch) {
      this.setState({
        total: apiResult.meta.total,
        perPage: apiResult.meta.perPage
      });
    }
    this.setSelectedCoworker(coworkers.slice(0).shift());
  }

  addCoworker () {
    this.setState({
      addingCoworker: true
    }, () => {
      let selectedCoworkerId = this.refs.coworker.value;
      this.props.addCoworker(this.getCoworker(selectedCoworkerId));
    });
  }

  getCoworker (selectedCoworkerId) {
    return _.find(this.state.coworkers, function (o) {
      return selectedCoworkerId === o.id;
    });
  }

  renderSpinner () {
    if (this.state.fetching) {
      return (<div className="spinner"><Spinner size={25}/></div>);
    }
  }

  handleCoworkerChange (e) {
    this.setSelectedCoworker(this.getCoworker(e.target.value));
  }

  coworkerSearch = (e) => {
    const value = e.target.value;
    if (value.length >= 3) {
      this.setState({
        fetching: true
      }, function () {
        WorkerService.searchByLastName(value).then((response) => {
          this.setState({
            coworkerSearch: true
          });
          this.handleFetchWorkersResponse(response);
        }).catch(() => {
          this.setState({
            fetchError: true,
            fetching: false
          });
        });
      });
    }
  }

  setSelectedCoworker (coworker) {
    this.setState({
      selectedCoworker: coworker
    });
  }

  addButtonText () {
    let text = proxyCounterpart('ADD');
    let name = '';

    if (this.state.selectedCoworker) {
      if (!this.state.selectedCoworker.disabledInSelect) {
        name += ' ' + this.state.selectedCoworker.firstName;
        name += ' ' + this.state.selectedCoworker.lastName;
      } else {
        this.state.coworkers.forEach((worker) => {
          if (!worker.disabledInSelect) {
            if (name.length < 5) {
              name += ' ' + worker.firstName;
              name += ' ' + worker.lastName;
            }
          }
        });
      }
    }

    return text + name;
  }

  renderCoworkerSelect () {
    let select = null;
    let search = null;
    const state = this.state;

    if (state.total > state.perPage) {
      search = (
        <div>
          <h3><Translate content='SEARCH_COWORKER'/></h3>
          <input type="text" onChange={this.coworkerSearch}></input>
        </div>
      );
    }

    if (!state.fetching) {
      if (state.coworkers.length) {
        if ((state.total <= state.perPage) || state.coworkerSearch) {
          select = (
            <div>
              <div className='styled-select'>
                <select
                  ref={'coworker'}
                  onChange={this.handleCoworkerChange}>
                  {
                    state.coworkers.map(function (item, i) {
                      return (
                        <option
                          value={item.id}
                          key={i}
                          disabled={item.disabledInSelect}>
                          {item.fullNamePersonalCode}
                        </option>
                      );
                    })
                  }
                </select>
              </div>
              <SpinnerButton
                text={this.addButtonText()}
                graySpinner={'true'}
                loading={this.state.addingCoworker}
                classes='btn outlined blue'
                callback={this.addCoworker}
              />
            </div>
          );
        }
      } else {
        select = (<span>{proxyCounterpart('NO_COWORKERS_ADD_NEW_BELOW')}</span>);
      }
    }

    return (
      <div className="coworker-select-wrapper">
        {search}
        {select}
        {this.renderSpinner()}
      </div>
    );
  }

  render () {
    return (
      <div className='addCoworker'>
        <h2><Translate content='ADD_COWORKER'/></h2>
        {this.renderCoworkerSelect()}
        <hr />
        <div className='button-holder'>
          <div className="btns-left">
            <a className='btn' onClick={this.props.addNewCoworker}>
              <span>
                <Translate content='ADD_NEW_COWORKER'/>
              </span>
            </a>
          </div>
          <div className="btns-right">
            <a className='btn outlined blue close-btn' onClick={this.props.close}>
              <span><Translate content='CLOSE'/></span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default AddCoworker;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/add-coworker.js
 **/